﻿$.fn.dxCtrlChartResumeEnvoi = function custom_dxCtrlChartResumeEnvoi(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlchartresumeenvoi dx-ctrl");
        this.createInstance(new cdxCtrlChartResumeEnvoi(this, option));
    }
    return this;
}

window.cdxCtrlChartResumeEnvoi = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    function mConstruit() {
        container.empty()
        container.css({ "height": "100%", "width": "100%" })
        Me.mUpdate()
    }

    var dxChart = null
    var oldDs = null
    function mRempli(ds) {
        if (dxChart == null) {
            dxChart = $("<div/>").appendTo(container).dxTreeMap({
                palette: "Pastel",
                dataSource: ds,
                size: {
                    width: 200,
                    height: 200
                },
                colorField: "color",
                hoverEnabled: false,
                tooltip: {
                    enabled: true,
                    container:container,
                    customizeTooltip(arg) {
                        return {
                            text: "(" + arg.value + ") " +arg.node.data.name,
                        };
                    },
                },
                commonSeriesSettings: {
                    label: {
                        visible: true,
                        customizeText: function (arg) {
                            return parseFloat(arg.totalText).formatDisplay(0) + ""
                            //debugger;
                        }
                    },
                },
                //series: {
                //    argumentField: 'lib',
                //    valueField: 'value',
                //    type: 'bar'
                //},
                //legend: {
                //    visible: false
                //}
            }).dxTreeMap("instance");
            //dxChart = $("<div/>").appendTo(container).dxChart({
            //    palette: "Pastel",
            //    dataSource: ds,
            //    width: "100%",
            //    height: "100%",
            //    commonSeriesSettings: {
            //        label: {
            //            visible: true,
            //            customizeText: function (arg) {
            //                return parseFloat(arg.totalText).formatDisplay(0) + ""
            //                //debugger;
            //            }
            //        },
            //    },
            //    series: {
            //        argumentField: 'lib',
            //        valueField: 'value',
            //        type: 'bar'
            //    },
            //    legend: {
            //        visible: false
            //    }
            //}).dxChart("instance");
            oldDs = ds
        } else {
            if (JSON.stringify(oldDs) != JSON.stringify(ds)) {
                dxChart.option("dataSource", ds)
                oldDs = ds
            }
        }
    }

    this.mUpdate = function (data) {
        if (typeof data == 'undefined') {
            option.bddCtrl.mAjaxCall({ command: "getresumeenvoi", id_table_com: option.idTableCom, id_com: option.idCom }, function (data) {
                Me.mUpdate(data.stat[0])
            })
        } else {
            var ds = [{
                name: "Résumé des envois",
                items: [{
                    name: "Envoyés",
                    color: "green",
                    value: parseInt(data.nb_envoi - data.nb_envoi_degrade)
                },{
                    name: "Envoyés dégradés",
                    color: "olive",
                    value: parseInt(data.nb_envoi_degrade)
                }, {
                    name: "Attente d'envoi",
                    color: "gray",
                    value: parseInt(data.nb_attente)
                }, {
                    name: "Annulés",
                    color: "#ff6666",
                    value: parseInt(data.nb_annule)
                }, {
                    name: "Bounce",
                    color: "red",
                    value: parseInt(data.nb_listebounce)
                }, {
                    name: "Liste noire",
                    color: "orange",
                    value: parseInt(data.nb_listenoire)
                }]
            }]
            //var ds = [{
            //    lib: "Nb envoi",
            //    value: parseInt(data.nb_total - data.nb_annule)
            //}, {
            //    lib: "Nb reçu",
            //    value: parseInt(data.nb_envoyer - data.nb_bounce)
            //}]
            ////if (option.idTableCom == option.bddCtrl.getObjet("com_email_envoi").mGetTable().id_table) {
            //ds.push({
            //    lib: "Nb vue",
            //    value: parseInt(data.nb_vue)
            //})
            ////}
            //ds.push({
            //    lib: "Nb click",
            //    value: parseInt(data.nb_click)
            //})
            mRempli(ds)
        }
    }

    this.element = function () { return container }
    this.focus = function () { }

    mConstruit();
}